// extracted by mini-css-extract-plugin
export var container = "_5k-1";
export var editor = "_5k-2";
export var resizable = "_5k-3";
export var wrapper = "_5k-0";